exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".relationships h3 {\n  margin-bottom: 20px; }\n\n.relationships p {\n  margin-bottom: 65px; }\n\n.relationships a {\n  padding: 5px 15px;\n  display: inline-block; }\n\n.relationships a:focus {\n    outline: none; }\n\n.relationships a img {\n    width: 100%;\n    opacity: 0.4;\n    display: inline-block; }\n\n.relationships a:hover img {\n    opacity: 1; }\n\n.relationships .custom-style {\n  margin: 20px 0; }\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .relationships h3 {\n    margin-bottom: 12px; }\n  .relationships p {\n    margin-bottom: 45px; }\n  .relationships .custom-style {\n    margin: 0; } }\n\n@media (min-width: 576px) and (max-width: 767px) {\n  .relationships h3 {\n    margin-bottom: 12px; }\n  .relationships p {\n    margin-bottom: 45px; }\n  .relationships .custom-style {\n    margin: 0; } }\n\n@media (max-width: 575px) {\n  .relationships h3 {\n    margin-bottom: 12px; }\n  .relationships p {\n    margin-bottom: 30px; }\n  .relationships .custom-style {\n    margin: 0 0 45px 0; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/relation-ships/relation-ships.component.scss
// module id = ../../../../../src/app/shared/relation-ships/relation-ships.component.scss
// module chunks = main